import React, { FC } from 'react'
import styles from './EntityCardHeader.module.scss'
import { EntityCardHeaderProps } from './EntityCard.model'

export const EntityCardHeader: FC<EntityCardHeaderProps> = ({ children }) => (
  <div className={styles.infos}>{children}</div>
)
